export default "$ yarn add vuetify\n// OR\n$ npm install vuetify\n";